<template>
  <main>
    <div class="container-fluid message page-note-detail">
      <TopTemplate>
        <template #right-element>
          <div class="d-flex buttons-wrapper">
            <a @click="$router.go(-1)" class="btn btn-outline-primary button" :disabled="loading">
              <i class="arrow left"></i>
              {{ $t("button.retour") }}
            </a>

            <router-link :to="{name: 'addNote'}" class="btn button btn-primary" :disabled="loading">
              <i class="icon-Add" />
              {{ $t("button.addNote") }}
            </router-link>
          </div>
        </template>
        <template #left-element>
          <div>
            <div class="title">
              <h3>{{ $t("title.listnoteDetail") }}</h3>
              <span class="long-number"> ({{ total }})</span>
            </div>
            <div class="prev-title test-title">{{ className }} - {{ yearName }}</div>
          </div>
        </template>
      </TopTemplate>
      <div class="search-date-wrapper search-filter-wrapper" :class="showFil === false ? 'borderNan' : ''">
        <div class="col-md-11 search searchTeacher">
          <input v-model="params.course_name" type="text" placeholder="Recherche" name="search" @input="searshTeacher()" />
          <img src="../../assets/icons/search-icon.svg" class="icon-search" alt="search" />
        </div>
        <div class="date-wrapper filter-wrapper" @click="showFilter()">
          <span>{{ $t("barFiltre.filtre") }}</span>
        </div>
      </div>
      <div v-if="showFil" class="row container-select container-filter">
        <div class="col-md-12">
          <div class="reset_student reset_note" @click="resetFilter()">
            <i class="icon-reset" />
            {{ $t("notes.reset") }}
          </div>
        </div>
        <div class="col-md-12">
          <p class="filter_critere">{{ $t("common.c_recherche") }}</p>
        </div>
        <div class="col-md-4 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.period_id"
            :options="period_id"
            placeholder="Période"
            :searchable="true"
            label="period"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event, 1)"
          >
            <template #no-options="{}">
              {{ $t("common.emptySystem") }}
            </template>
          </v-select>
        </div>
        <div class="col-md-4 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.course_id"
            :options="course_id"
            :searchable="true"
            placeholder="Matière"
            label="name"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event, 2)"
          >
            <template #no-options="{}">
              {{ $t("common.emptysearchClasse") }}
            </template>
          </v-select>
        </div>
        <div class="col-md-4 select-wrapper">
          <span class="title-select"></span>
          <v-select
            v-model="params.exam_id"
            :options="exam_id"
            :searchable="true"
            placeholder="Devoir"
            label="label"
            :reduce="(option) => option.id"
            @update:modelValue="Changeselectedfilter($event, 3)"
          >
            <template #option="{name}">
              {{ name }}
            </template>
            <template #no-options="{}">
              {{ $t("common.emptysearchCourse") }}
            </template>
          </v-select>
        </div>
      </div>
      <div v-if="loading" class="col-md-12">
        <div v-if="loading" class="card mt-4 text-center d-block pt-4 pb-4">
          <div class="spinner-border text-info" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      </div>
      <div class="container-fluid empty-message">
        <div class="col-md-12">
          <div v-if="!loading && matiers.length === 0" class="card mt-4">
            <div class="col-12 empty-result text-center pt-3">
              <p>{{ $t("common.emptyNoteSelected") }}</p>
            </div>
          </div>
        </div>
      </div>

      <div class="table teacher table-note" v-if="!loading && matiers.length > 0">
        <div class>
          <div class="row">
            <div class="col-md-12">
              <div class="table__wrapper table-responsive-vertical table-responsive">
                <table class="table">
                  <thead>
                    <tr class="row">
                      <th class="col-md-2">{{ $t("notes.tab.matiere") }}</th>
                      <th class="col-md-2">{{ $t("notes.tab.periode") }}</th>
                      <th class="col-md-2">{{ $t("notes.tab.devoir") }}</th>
                      <th class="col-md-2">{{ $t("notes.tab.update") }}</th>
                      <th class="col-md-2">statut</th>
                      <th class="col-md-2 view">{{ $t("common.actions") }}</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="matier in matiers" :key="'key_' + matier" class="row">
                      <td class="col-md-2">
                        <div class="row">
                          <p class="classe-title">{{ matier.course_name }}</p>
                        </div>
                      </td>
                      <td class="col-md-2">
                        <p>{{ matier.period_name }}</p>
                      </td>
                      <td class="col-md-2">
                        <p>{{ $t("common." + matier.tdevoir) }}</p>
                      </td>
                      <td class="col-md-2">
                        <p>{{ dateTime(matier.updated_at) }}</p>
                      </td>
                      <td class="col-md-2">
                        <p v-if="matier.sdevoir === 1" class="status publie">Publié</p>
                        <p v-else-if="matier.sdevoir === 0" class="status brouillon">Brouillon</p>
                      </td>

                      <td class="col-md-2 action">
                        <div class="espace_height" @click="updatState(matier)">
                          <p>
                            <router-link
                              class="success_msg"
                              :to="{
                                name: 'DetailnoteSubject',
                                params: {classid: classId, courseid: matier.course_id, coursePeriode: matier.period_id},
                              }"
                            >
                              <i class="icon-eyes">
                                <span class="tooltiptext">{{ $t("button.tooltip.details") }}</span>
                              </i>
                            </router-link>
                            <router-link
                              v-if="schoolYearStatus"
                              class="success_msg"
                              :to="{
                                name: 'editNote',
                                params: {classid: classId, courseid: matier.course_id, periodid: matier.period_id, examtypeid: matier.tdevoir},
                              }"
                            >
                              <i class="icon-edit-02">
                                <span class="tooltiptext">{{ $t("button.tooltip.update") }}</span>
                              </i>
                            </router-link>
                          </p>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <div class="col-md-12 modal_dis">
                  <div class="col-md-12">
                    <div class="table__wrapper__pagination-wrapper">
                      <div class="pagination">
                        <pagination v-if="last_page > 1" :dataSet="pagination" @goToPage="getResults" />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

  <script>
import TopTemplate from "../../components/toptemplate/TopTemplate.vue";
import pagination from "../../components/navigation/Pagination";
import NoteDetailService from "../../services/notedetail.service";
import vSelect from "vue-select";
import moment from "moment";
import {mapGetters} from "vuex";

export default {
  components: {
    TopTemplate,
    pagination,
    "v-select": vSelect,
  },
  setup() {
    return {};
  },
  data() {
    return {
      loading: false,
      pagination: {},
      total: 0,
      last_page: null,
      showFil: false,
      params: {
        period_id: null,
        course_id: null,
        exam_id: null,
        exam_code: null,
        limit: 10,
        course_name: "",
        sort: "created_at",
      },
      matiers: [],
      period_id: [],
      course_id: [],
      exam_id: [],
      moment: null,
      selectPeriodId: null,
      selectCourseId: null,
      classId: null,
      className: null,
      yearName: null,
      loadingData: null,
      storedData: {},
      schoolYearId: null,
      schoolYearStatus: null,
    };
  },
  created() {
    this.moment = moment;
    this.classId = this.$route.params.id;
    this.loadingData = this.getDate;
  },
  computed: {...mapGetters(["getdataClass", "getDate"])},
  watch: {
    getdataClass(newValue, oldValue) {
      if (newValue) {
        this.className = newValue.name;
        this.yearName = newValue.school_year;
      }
    },
  },
  async mounted() {
    if (localStorage.getItem("dateDataClass")) {
      this.storedData = localStorage.getItem("dateDataClass");
      let myData = JSON.parse(this.storedData);
      this.className = myData.name;
      this.yearName = myData.school_year;
    }
    await this.ListNote();
    await this.getFiltre();
  },
  methods: {
    Changeselectedfilter(e, type) {
      if (type != 3) {
        this.getFiltre();
      }
      //   if (type === 1) {
      //     this.params.course_id = null;
      //     this.params.exam_id = null;
      //   }
      //   if (type === 2) {
      //     this.params.exam_id = null;
      //   }
      this.getResults();
    },
    showFilter() {
      this.showFil = !this.showFil;
    },
    async getFiltre() {
      this.loading = true;
      await NoteDetailService.getFilterNote(this.classId, {
        params: {
          period_id: this.params.period_id,
          course_id: this.params.course_id,
          school_year: this.schoolYearId,
        },
      })
        .then(
          (response) => {
            this.period_id = _.orderBy(response.data.period, "name");
            //www.myschool.localhost/messages
            http: this.course_id = _.orderBy(response.data.courses, "name");
            this.exam_id = _.orderBy(response.data.exam, "name");
            this.exam_id.map((item) => {
              item.id = item.exam_type;
              item.label = this.$t("common." + item.exam_type);
              item.name = this.$t("common." + item.exam_type);
            });
          },
          (error) => {
            this.loading = false;
          }
        )
        .finally(() => {
          this.loading = false;
        });
    },
    resetFilter() {
      this.params.period_id = null;
      this.selectPeriodId = null;
      this.params.course_id = null;
      this.params.exam_id = null;
      this.selectCourseId = null;
      this.ListNote();
      this.getFiltre();
    },
    specTri(param, order) {
      if (this.params.order === null && this.params.sort === "") {
        return "";
      } else {
        if (this.params.sort === param) {
          if (this.params.order === order) {
            return "ordredA";
          } else {
            return "ordredD";
          }
        } else {
          return "";
        }
      }
    },
    sortB: _.debounce(function (param) {
      this.params.order = this.params.order === false ? true : false;
      this.params.sort = param;
      this.ListNote();
    }, 200),
    sort(order, sort) {
      this.params.order = order;
      this.params.sort = sort;
      this.ListNote();
    },
    dateTime(value) {
      return moment(value).locale("fr").format("YYYY-MM-DD");
    },
    async ListNote() {
      this.loading = true;
      let config = {
        params: {
          period_id: this.params.period_id,
          course_id: this.params.course_id,
          exam_code: this.params.exam_id,
          limit: this.params.limit,
          course_name: this.params.course_name,
        },
      };
      await NoteDetailService.getAll(this.classId, config)
        .then((response) => {
          this.matiers = response.data.data;
          this.schoolYearId = response.data.school_year_id;
          this.schoolYearStatus = response.data.school_year_status;

          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.last_page = response.data.meta.last_page;
          this.loading = false;
        })
        .catch((error) => {
          this.loading = false;
          if (error.response && error.response.status === 404) {
            this.$router.push("/error-404");
          }
        });
    },
    makePagination(meta, links) {
      return {
        current_page: meta.current_page,
        last_page: meta.last_page,
        next_page_url: links.next,
        prev_page_url: links.prev,
      };
    },
    getResults(page = null) {
      this.selected = [];
      this.params.page = !page ? this.params.page : page;
      this.loading = true;
      let config = {
        params: {
          period_id: this.params.period_id,
          course_id: this.params.course_id,
          exam_code: this.params.exam_id,
          limit: this.params.limit,
          course_name: this.params.course_name,
          page: this.params.page,
        },
      };
      NoteDetailService.getAll(this.classId, config)
        .then((response) => {
          this.matiers = response.data.data;
          this.pagination = this.makePagination(response.data.meta, response.data.links);
          this.total = response.data.meta.total;
          this.loading = false;
        })
        .catch((error) => {})
        .finally(() => {
          this.loading = false;
        });
    },
    searshTeacher: _.debounce(function () {
      if (this.params.course_name.toString().length > 2 || !this.params.course_name.toString().length) {
        this.params.hasfilter = true;
        this.ListNote();
      }
    }, 200),
    updatState(data) {
      this.$store.commit("SET_DATA", data);
      const jsonString = JSON.stringify(data);
      localStorage.setItem("ObjectData", jsonString);
    },
  },
};
</script>

  <style lang="scss" scoped>
.empty-message {
  padding: 0;
}
span.long-number {
  color: #377879;
  font-weight: 700;
  margin-left: 3px;
}
.status {
  font-size: 10px;
  font-weight: 400;
  line-height: 20px;
  letter-spacing: 0em;
  text-align: left;
  padding: 5px;
  border-radius: 5px;
  max-width: max-content;
}
.publie {
  color: #377879;
  background-color: #f1fafa;
}
.brouillon {
  color: #f35b19;
  background-color: #f35b190f;
}
.page-note-detail {
  .espace_height {
    p {
      display: flex;
      justify-content: center;
    }
  }
  table tbody .icon-edit-02 {
    color: #f35b19;
  }
  .prev-title {
    color: #3d3d3d;
    font-size: 14px;
    font-style: normal;
    font-weight: 500;
  }
  .reset_student {
    color: #34b9bb;
    font-size: 14px;
    font-weight: 600;
  }
  .top-template {
    .buttons-wrapper {
      a {
        &:last-child {
          margin-left: 10px;
        }
      }
    }
  }
  .search-filter-wrapper {
    margin: 0 !important;
  }
  .filter_critere {
    font-size: 11px;
    font-style: normal;
    font-weight: 400;
    line-height: 20px;
    margin-bottom: 10px;
  }
  .vs__search {
    &::placeholder {
      font-size: 12px;
      font-style: normal;
      font-weight: 400;
    }
  }
  .table-note {
    .table__wrapper {
      padding: 0 15px !important;
      .table {
        thead {
          tr {
            border-bottom-width: 3px;

            th {
              padding-top: 18px;
              padding-bottom: 18px;
              &:first-child {
                padding-left: 30px;
              }
              &:last-child {
                padding-right: 30px;
                padding-left: 0;
              }
            }
          }
        }
        tbody {
          tr {
            td {
              &:first-child {
                padding-left: 30px;
              }
              &:last-child {
                padding-right: 30px;
              }
              p {
                margin-top: 0;
                margin-bottom: 0;
                &.classe-title {
                  color: #333;
                  font-size: 12px;
                  font-style: normal;
                  font-weight: 600;
                }
              }
            }
          }
        }
        .action {
          text-align: center;
          p {
            padding: 13px;
          }
        }
        .view {
          text-align: center;
        }
      }
    }
  }
}
</style>
